import { render, staticRenderFns } from "./freePuzzle.vue?vue&type=template&id=6103de65&scoped=true"
import script from "./freePuzzle.vue?vue&type=script&lang=js"
export * from "./freePuzzle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6103de65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6103de65')) {
      api.createRecord('6103de65', component.options)
    } else {
      api.reload('6103de65', component.options)
    }
    module.hot.accept("./freePuzzle.vue?vue&type=template&id=6103de65&scoped=true", function () {
      api.rerender('6103de65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/components/freePuzzle.vue"
export default component.exports